import { createVanIconComponent } from "./van"

const SendGiftOutlined = createVanIconComponent("send-gift-o")
export default SendGiftOutlined
